module.exports = __webpack_public_path__ + "img/prize-04.4a0fb2d4.png";